
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/produto/[slug]",
      function () {
        return require("private-next-pages/produto/[slug].tsx");
      }
    ]);
  